import { useState } from 'react';

import useAccessManagement from 'hooks/useAccessManagement';

import { Common } from 'utils';

const getStateValue = () => {
  try {
    const sessionValue = Common.getSessionValue('logCookie');
    if (!sessionValue || !sessionValue.includes('name')) {
      Common.setSessionValue('logCookie', null);
      Common.clearCacheData();
      return null;
    }
    const parsedData = JSON.parse(sessionValue)?.permission;
    return parsedData;
  } catch (err) {
    return null;
  }
};

function ProtectedRoute({ roles, children, requireAccessManagement = false }) {
  const [manager] = useState(roles?.includes(getStateValue()));
  const canManage = useAccessManagement(requireAccessManagement);
  if (manager && (!requireAccessManagement || canManage)) {
    return children;
  }
  return null;
}

export default ProtectedRoute;
